import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-600 shadow-sm hover:shadow-md',
    secondary: 'bg-blue-900 text-white hover:bg-blue-800 focus:ring-blue-900 shadow-sm',
    outline: 'border-2 border-blue-900 text-blue-900 hover:bg-blue-50 focus:ring-blue-900',
    ghost: 'text-blue-900 hover:bg-blue-50 hover:text-blue-700'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm rounded-md',
    md: 'h-11 px-6 text-base rounded-md',
    lg: 'h-14 px-8 text-lg rounded-md'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-207">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-208" />}
      {children}
    </button>;
}